import React, { useState } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';

const AccordionPanel = ({ title, children, defaultOpen = true, onBackClick }) => {
  const [openItem, setOpenItem] = useState(defaultOpen ? 'item-1' : '');

  const handleValueChange = value => {
    setOpenItem(value);
    if (!value && onBackClick) {
      onBackClick(); // ✅ Trigger when collapsed
    }
  };

  return (
    <Accordion.Root type="single" collapsible value={openItem} onValueChange={handleValueChange}>
      <Accordion.Item value="item-1" className="border rounded shadow-sm mb-4">
        <Accordion.Header>
          <Accordion.Trigger className="w-full flex justify-between items-center px-4 py-2 bg-blue-100 font-bold rounded-t">
            {title}
            <ChevronDown className="h-4 w-4 transition-transform group-data-[state=open]:rotate-180" />
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content className="px-4 py-2 bg-white border-t">
          {children}
          {onBackClick && (
            <div className="mt-4 text-right">
              <button
                onClick={onBackClick}
                className="text-sm text-blue-600 underline hover:text-blue-800"
              >
                ← חזור לתצוגת הבניין
              </button>
            </div>
          )}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};

export default AccordionPanel;
